import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function TaskCompletionFailedCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-rose-300 bg-rose-50 p-4 text-sm text-rose-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-rose-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-rose-900">
          Update failed
        </span>
        {answer.apply_error && (
          <span className="text-xs text-rose-800">{answer.apply_error}</span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
      {answer.audit_id && (
        <p className="mt-2 text-[10px] uppercase tracking-wide text-rose-700">
          audit: {String(answer.audit_id).slice(0, 8)}
        </p>
      )}
    </article>
  );
}
